import { Check } from "lucide-react";
import { STATUS_LABEL } from "../lib/api";

const STEPS = ["paid", "pending_supplier", "accepted", "installation_scheduled", "active"];
const BAD = ["rejected", "cancelled", "failed"];

export const StatusBadge = ({ status }) => {
  const tone = BAD.includes(status) || status === "payment_failed" || status === "unpaid"
    ? "bg-red-50 text-red-700"
    : ["active", "paid", "approved", "registered", "answered", "published"].includes(status)
      ? "bg-emerald-50 text-emerald-700"
      : "bg-amber-50 text-amber-800";
  return <span data-testid={`status-badge-${status}`} className={`inline-block rounded px-2 py-0.5 text-xs font-semibold ${tone}`}>{STATUS_LABEL[status] || status}</span>;
};

export const StatusTimeline = ({ status }) => {
  if (BAD.includes(status)) return <StatusBadge status={status} />;
  const idx = STEPS.indexOf(status);
  return (
    <ol data-testid="order-status-timeline" className="flex w-full items-start">
      {STEPS.map((s, i) => {
        const done = i <= idx;
        return (
          <li key={s} className="flex flex-1 flex-col items-center text-center">
            <div className="flex w-full items-center">
              <span className={`h-0.5 flex-1 ${i === 0 ? "opacity-0" : done ? "bg-secondary" : "bg-border"}`} />
              <span className={`grid h-6 w-6 shrink-0 place-items-center rounded-full border-2 text-[10px] font-bold ${done ? "border-secondary bg-secondary text-white" : "border-border bg-white text-muted-foreground"} ${i === idx ? "ring-4 ring-secondary/20" : ""}`}>
                {done ? <Check className="h-3 w-3" /> : i + 1}
              </span>
              <span className={`h-0.5 flex-1 ${i === STEPS.length - 1 ? "opacity-0" : i < idx ? "bg-secondary" : "bg-border"}`} />
            </div>
            <span className={`mt-1.5 text-[10px] leading-tight sm:text-xs ${done ? "font-semibold text-foreground" : "text-muted-foreground"}`}>{STATUS_LABEL[s]}</span>
          </li>
        );
      })}
    </ol>
  );
};
